export default __webpack_public_path__ + "static/media/banner_registro.cb776c87.jpg";